module.exports = __webpack_public_path__ + "static/media/TheHistoriaDemo-01.70dccbd1.svg";